import categories from './categories';
import subcategories from './subcategories';
import preparations from './preparations';
import mixables from './mixables';
import { combineReducers } from 'redux'

export default combineReducers({
  categories,
  subcategories,
  preparations,
  mixables
});
